module.exports = __webpack_public_path__ + "img/undraw_programming_2svr@2x.f7234a23.png";